/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceChallengeZoneLeaderEntry
 */
export interface SurfaceChallengeZoneLeaderEntry {
    /**
     * 
     * @type {number}
     * @memberof SurfaceChallengeZoneLeaderEntry
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneLeaderEntry
     */
    avatarUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceChallengeZoneLeaderEntry
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof SurfaceChallengeZoneLeaderEntry
     */
    score: number;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceChallengeZoneLeaderEntry
     */
    isCurrentUser?: boolean;
}

/**
 * Check if a given object implements the SurfaceChallengeZoneLeaderEntry interface.
 */
export function instanceOfSurfaceChallengeZoneLeaderEntry(value: object): value is SurfaceChallengeZoneLeaderEntry {
    if (!('rank' in value) || value['rank'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function SurfaceChallengeZoneLeaderEntryFromJSON(json: any): SurfaceChallengeZoneLeaderEntry {
    return SurfaceChallengeZoneLeaderEntryFromJSONTyped(json, false);
}

export function SurfaceChallengeZoneLeaderEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceChallengeZoneLeaderEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
        'name': json['name'],
        'score': json['score'],
        'isCurrentUser': json['isCurrentUser'] == null ? undefined : json['isCurrentUser'],
    };
}

export function SurfaceChallengeZoneLeaderEntryToJSON(json: any): SurfaceChallengeZoneLeaderEntry {
    return SurfaceChallengeZoneLeaderEntryToJSONTyped(json, false);
}

export function SurfaceChallengeZoneLeaderEntryToJSONTyped(value?: SurfaceChallengeZoneLeaderEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
        'avatarUrl': value['avatarUrl'],
        'name': value['name'],
        'score': value['score'],
        'isCurrentUser': value['isCurrentUser'],
    };
}

